import * as React from 'react';
import Grid from "@mui/material/Grid2"
import { Box } from "@mui/system"
import dayjs from "dayjs"
import UserAvatar from "../UserAvatar";
import { findUser, useUsers } from '../ReactQuery/QueryUsers';
import { useTrackedDarkMode } from '../UserState';

export default function ServiceNote({ serviceNote }) {
    const { data: users, } = useUsers();
    const [darkMode,] = useTrackedDarkMode();
    const user = findUser(users, serviceNote.user_id)
    return (<Box key={serviceNote.id} sx={{ mb: 1 }}>
        <Grid container space={1} sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            <Grid xs="auto">
                <span>{dayjs.utc(serviceNote.date_created).local().format('M/D/YYYY h:mm A')}</span>
            </Grid>
            <Grid xs="auto" sx={{ pr: 1, pl: 1 }}>
                <UserAvatar user={user} sx={{ height: '24px', width: '24px', fontSize: '0.9rem' }} />
            </Grid>
            <Grid xs="auto">
                <span>{user?.name}</span>
            </Grid>
            {serviceNote.type === "diagnostic" &&
                <Grid xs="auto" sx={{ pl: 1, fontWeight: 'normal' }}>
                    <span style={{ color: 'grey' }}>Diagnostic</span>
                </Grid>
            }
            {serviceNote.type === "overhead" &&
                <Grid xs="auto" sx={{ pl: 1, fontWeight: 'normal' }}>
                    <span style={{ color: 'grey' }}>Overhead</span>
                </Grid>
            }
            {serviceNote.type === "work_history" &&
                <Grid xs="auto" sx={{ pl: 1, fontWeight: 'normal' }}>
                    <span style={{ color: 'grey' }}>Work Note ({serviceNote.service_name})</span>
                </Grid>
            }
        </Grid>
        <Box sx={{ 'whiteSpace': 'pre-wrap', m: 1, p: 0.5, bgcolor: `backgroundColor.${darkMode ? 'light' : 'dark'}`, borderRadius: "8px 8px 0 0" }}>
            <span>{serviceNote.text}</span>
        </Box>
    </Box>)
}